document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.infoBar__wrapper').forEach(function (slider) {
        new Splide(slider, {
            type: 'loop',
            pagination: false,
            arrows: false,
            autoWidth: true,
            clones: 5,
            perPage: 1,
            perMove: 1,
            gap: '240px',
            autoScroll: {
                speed: 0.5,
            },
            breakpoints: {
                768: {
                    gap: '80px',
                }
            }
        }).mount(window.splide.Extensions);
    });
});